<template>
  <image-list :images="data" v-slot:img="{ img, height }" :loading="loading">
    <div class="images-item__wrap">
      <div class="images-list__item">
        <el-card class="img-card" :body-style="{ padding: '0px' }">
          <div style="position: relative;">
            <el-image
              lazy
              fit="cover"
              :src="img.tempPath"
              :style="{ height: `${height}px`, width: '100%' }"
              @click="showModel(img.id)"
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>

            <div class="float right-bottom">
              <span>{{ img.createdAt | formatDate }}</span>
            </div>

            <el-popover
              v-if="img.distinguishCount"
              class="float left-top"
              trigger="hover"
              placement="right"
              popper-class="pictures-insect__popover"
            >
              <div
                v-for="insect in img.insects"
                :key="insect.id"
                class="pictures-insect"
              >
                <div>
                  {{ insect.category }}
                </div>
                <div class="pictures-insect__value">
                  {{ insect.qty || 0 }}
                </div>
              </div>

              <div slot="reference">
                <span>识别：{{ img.distinguishCount }}</span>
              </div>
            </el-popover>
          </div>
          <div class="images-list__footer">
            <div class="cell">编号：{{ img.id }}</div>
            <div class="cell">设备：{{ img.device }}</div>
          </div>
        </el-card>
      </div>
    </div>
  </image-list>
</template>

<script>
import ImageList from '@/components/Images'
export default {
  components: { ImageList },
  props: {
    loading: Boolean,
    data: Array
  },
  data() {
    return {
      height: 0
    }
  },
  methods: {
    showModel(id) {
      this.$emit('show-model', id)
    }
  }
}
</script>

<style lang="scss">
.pictures-insect__popover {
  padding: 8px;
  background: rgba(50, 50, 50, 1);
  color: #fff;
  min-width: 80px;
  .popper__arrow:after {
    border-right-color: rgba(50, 50, 50, 1) !important;
  }
}
.pictures-insect {
  display: flex;
  flex-direction: row;
  &:not(:first-child) {
    margin-top: 4px;
  }
  .pictures-insect__marker {
    display: inline-block;
    margin-right: 5px;
    border-radius: 10px;
    width: 10px;
    height: 10px;
  }
  .pictures-insect__value {
    flex: 1;
    margin-left: 1rem;
    text-align: right;
  }
}
.image-slot {
  background-color: rgba(50, 50, 50, 0.3);
  color: #fff;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

<style scoped lang="scss">
.float {
  text-shadow: 0px 0px 2px #000;
}
</style>
